export const BRAND_NAME = "RIDHI SIDHI"
export const EMAIL = 'ridhisidhiflourmills@gmail.com'
export const MOBILE_NO = '7015523400'
export const ADDRESS = 'Rajkot, GUJRAT'